import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Carousel from 'react-bootstrap/Carousel';
import { Lightbox } from '../../../../src/web/components';
import ImageCarouselAsset from './ImageCarouselAsset';
import { pushRoute } from '../../../../modules/routing';
import styles from './ImageCarousel.scss';

const propTypes = {
  autoplay: PropTypes.bool,
  bannerText: PropTypes.string,
  images: PropTypes.arrayOf(PropTypes.shape({
    file: PropTypes.string,
    filename: PropTypes.string,
    staticImg: PropTypes.bool,
    alt: PropTypes.string,
    link: PropTypes.string,
    target: PropTypes.string,
  })),
  imageClassname: PropTypes.string,
  showBanner: PropTypes.bool,
  disableLightBox: PropTypes.bool,
  sizeGuide: PropTypes.bool,
};

const defaultProps = {
  autoplay: undefined,
  bannerText: undefined,
  images: [],
  imageClassname: undefined,
  showBanner: undefined,
  disableLightBox: undefined,
  sizeGuide: undefined,
};

const onClickImage = img => (e) => {
  const { stopPropagation } = e;
  stopPropagation();
  const { link, target } = img;
  if (!link) {
    return null;
  }
  if (target === '_blank') {
    return window.open(link);
  }
  return pushRoute(link);
};

const ImageCarousel = ({
  images,
  autoplay,
  bannerText,
  imageClassname,
  showBanner,
  disableLightBox,
  sizeGuide,
}) => {
  const [lightboxIndex, setLightboxIndex] = useState(null);


  let filteredImages = images.filter(Boolean);
  if (!filteredImages.length) {
    filteredImages = [{ file: '/img/grid-4.jpg', alt: 'facility-image' }];
  }

  const banner = (
    <>
      {showBanner && bannerText && (
        <div className={styles.imageBanner}>
          <div className={cx(styles.wrapper, 'color-secondary-background')}>
            <p>{bannerText}</p>
          </div>
        </div>
      )}
    </>
  );

  const lightboxItems = () => {
    if (
      lightboxIndex === null
      || lightboxIndex < 0
      || lightboxIndex >= filteredImages.length
      || disableLightBox
    ) {
      return false;
    }

    const items = filteredImages.map((img, index) => (
      <ImageCarouselAsset
        lightbox
        asset={img}
        index={index}
        onClick={() => onClickImage(img)}
        mediaClassnames={cx(styles.lightboxItem, styles.image, { [styles.pointer]: img.link })}
      />
    ));

    const nextIndex = (lightboxIndex + 1) % items.length;
    const prevIndex = (lightboxIndex + (items.length - 1)) % items.length;

    const lightboxProps = {
      items,
      itemIndex: lightboxIndex,
      onClickClose: () => setLightboxIndex(null),
      onClickDot: setLightboxIndex,
      onClickNext: () => setLightboxIndex(nextIndex),
      onClickPrev: () => setLightboxIndex(prevIndex),
    };

    return <Lightbox {...lightboxProps} />;
  };

  const carouselItems = filteredImages.map((asset, idx) => (
    <Carousel.Item key={asset.file || asset.mediumId} className="pb-no-click">
      <div
        className={cx(styles.image, imageClassname)}
      >
        <ImageCarouselAsset
          asset={asset}
          index={idx}
          onClick={() => setLightboxIndex(idx)}
          mediaClassnames={cx(styles.image, styles.pointer, sizeGuide && styles.guideImage)}
        />
      </div>
    </Carousel.Item>
  ));

  return (
    <>
      {filteredImages.length === 1 ? carouselItems : (
        <Carousel
          interval={autoplay ? 5000 : null}
          indicators={false}
          controls={images.length > 1}
          prevIcon={<span className="icon icon-back-arrow" />}
          nextIcon={<span className="icon icon-select-arrow" />}
          className={styles.root}
        >
          {carouselItems}
        </Carousel>
      )}
      {banner}
      {lightboxItems()}
    </>
  );
};

ImageCarousel.propTypes = propTypes;
ImageCarousel.defaultProps = defaultProps;

export default ImageCarousel;
